import React from 'react'

interface AuthFormLayoutProps {
  body: React.ReactNode
  footer: React.ReactNode
}

export const AuthFormLayout = ({ body, footer }: AuthFormLayoutProps) => (
  <div className="flex flex-col gap-6 2xl:gap-8">
    <div className="flex flex-col gap-4">{body}</div>
    <div className="flex flex-col gap-3 md:gap-4">{footer}</div>
  </div>
)
